export default __webpack_public_path__ + "static/media/floor-design.d80e040a.png";